import { required, usePermissions } from "ra-core";

import { RadioButtonGroupInput } from "ra-ui-materialui";
import React from "react";

const MediaTypeInput = (props) => {
  const { permissions, loaded } = usePermissions();
  const isAdmin = loaded && permissions && permissions(["admin"]);
  if (!isAdmin) {
    return null;
  }
  return (
    <RadioButtonGroupInput
      {...props}
      choices={[
        {
          id: "pre",
          name: "resources.project-media.media_type.pre",
        },
        {
          id: "post",
          name: "resources.project-media.media_type.post",
        },
      ]}
      source="media_type"
      validate={required()}
    />
  );
};
export default MediaTypeInput;
